<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="grey lighten-2 text--primary font-weight-bold">
          Fornecedores sugeridos
        </v-subheader>
        <v-divider/>
        <v-list v-if="aprovacao.fornecedores && aprovacao.fornecedores.length"
                dense
                class="rounded-card pt-0">
          <template v-for="(fornecedor, index) in aprovacao.fornecedores">
            <v-list-item dense :key="fornecedor.id">
              <v-list-item-content>
                <v-list-item-title>
                  <px-span-tooltip
                    v-if="fornecedor.codigoInterno"
                    bottom
                    text-class="caption"
                    :text="`(${fornecedor.codigoInterno})`"
                    tooltip="Código interno do fornecedor"/>
                  {{ fornecedor.pessoa.nome }}
                  <px-popover-fornecedor :fornecedor-id="fornecedor.id" show-score />
                </v-list-item-title>
                <v-list-item-subtitle>
                  <px-fornecedor-documento :fornecedor="fornecedor"/>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index !== (aprovacao.fornecedores.length - 1)"
                      :key="`v-div-f${fornecedor.id}`"/>
          </template>
        </v-list>
        <v-card-text v-else>
          Nenhum fornecedor sugerido
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { DetalheFornecedorUtils } from 'px-components';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    mapFornecedores() {
      this.aprovacao.fornecedores = this.aprovacao.fornecedores.map(f => this.buildFornecedor(f));
    },
    buildFornecedor(fornecedor) {
      const { detalhesFornecedores } = this.aprovacao;
      const detalhe = DetalheFornecedorUtils.getDetalhe(fornecedor.id, detalhesFornecedores);
      return {
        ...fornecedor,
        codigoInterno: detalhe.codigoInterno,
        pessoa: {
          ...fornecedor.pessoa,
          nome: detalhe.nome || fornecedor.pessoa.nome,
        },
      };
    },
  },
  created() {
    this.mapFornecedores();
  },
};
</script>
